<div class="alert alert-warning d-flex align-items-end gap-2" role="alert">
    <div class="icon"><IconWarning></IconWarning></div>
    <div>{{label}}</div>
</div>